import { useState } from "react";
import { useCreateNote } from "../queries";
import { CategoryInput } from "./CategoryInput";
import { NoteEditor, preferredFormat } from "./NoteEditor";

export function Composer({ defaultCategory, onDone }: { defaultCategory?: string; onDone: (createdId?: string) => void }) {
  const create = useCreateNote();
  const [categories, setCategories] = useState(defaultCategory ? [defaultCategory] : []);

  return (
    <NoteEditor
      initial={{ title: "", body: "", format: preferredFormat() }}
      saving={create.isPending}
      error={create.isError ? "Couldn't save the note." : null}
      headerExtra={<CategoryInput value={categories} onChange={setCategories} />}
      onCancel={() => onDone()}
      onSave={async (draft) => {
        const note = await create.mutateAsync({
          title: draft.title.trim(),
          bodyText: draft.body,
          format: draft.format,
          categories,
        });
        onDone(note.id);
      }}
    />
  );
}
